import Components from 'components/components';


class Main {
	constructor() {
		// Setup site components
		this.components = new Components();
	}

	async load() {
		await this.components.load();
	}
}

const main = new Main();
await main.load();

window.jQuery2 = $;